module.exports = __webpack_public_path__ + "img/scyd.2e70e2ce.png";